import { useIonViewWillEnter, useIonViewWillLeave, useIonRouter, IonIcon, IonTextarea, IonGrid, IonRow, IonText, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Clipboard } from '@capacitor/clipboard';
import { clipboardOutline } from 'ionicons/icons';

import { showTab, hideTab } from "../components/Tabs";
import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import './Main.css'; 

interface ReportProp extends RouteComponentProps<{
    id : string,
    type : string
    }> 
{} 

const Report : React.FC<ReportProp> = ({match}) => {

    const [desc, setDesc] = useState("");
    const [link, setLink] = useState("");
    const [copyright, setCopyright] = useState(false);

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        hideTab();
    });

    useIonViewWillLeave(() => {
        showTab();
    });

    // paste the description
    const pasteDesc = async () => {
        const { type, value } = await Clipboard.read();
        setDesc(value);
    };

    const pasteLink = async () => {
        const { type, value } = await Clipboard.read();
        setLink(value);
    };

    // report to the admin
    const reportToAdmin = async () => {
        let v = new Vault();
        await v.read();

        let report = desc;
        if (link != "")
            report = desc + "\n\n" + "Link: " + link;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id,
            type: match.params.type,
            report: report
        }

        var server = new NServer();
        await server.sendForm("nc_report", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            showAlert(GetStr(LANGUAGE.TXT_REPORT_SUCCESS));

            // return
            router.push("/main", "back", "pop");
        }
    }

    return (
        <IonPage>
            <IonContent>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_REPORT_ADMIN) }</h5></IonTitle>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            {
                                copyright ?
                                /* copyright issue */
                            <div>
                                <div className="ion-padding">
                                    <IonText>{ GetStr(LANGUAGE.TXT_REPORT_COPYRIGHT_URL) }</IonText>
                                </div>
                                <div className="ion-padding">
                                    <IonItem>
                                        <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_COPYRIGHT_URL) }</IonLabel>
                                        <IonInput value={link} onIonChange={e => setLink(e.detail.value!)}></IonInput>
                                        <IonIcon icon={clipboardOutline} slot="end" onClick={pasteLink} />
                                    </IonItem>
                                </div>

                                <div className="ion-padding">
                                    <IonText>{ GetStr(LANGUAGE.TXT_EXPLAIN_COPYRIGHT) }</IonText>
                                </div>
                                <div className="ion-padding">
                                    <IonItem>
                                        <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_REPORT_CAP) }</IonLabel>
                                        <IonTextarea value={desc} rows={6} auto-grow maxlength={3000} onIonChange={e => setDesc(e.detail.value!)}></IonTextarea>
                                        <IonIcon icon={clipboardOutline} slot="end" onClick={pasteDesc} />
                                    </IonItem>
                                </div>
                            </div>
                                :
                            <div>
                                <div className="ion-padding">
                                    <IonText>{ GetStr(LANGUAGE.TXT_REPORT_ADMIN_DETAIL) }</IonText>
                                </div>
                                <div className="ion-padding">
                                    <IonItem>
                                        <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_REPORT_CAP) }</IonLabel>
                                        <IonTextarea value={desc} rows={6} auto-grow maxlength={3000} onIonChange={e => setDesc(e.detail.value!)}></IonTextarea>
                                        <IonIcon icon={clipboardOutline} slot="end" onClick={pasteDesc} />
                                    </IonItem>
                                </div>
                            </div>
                            }

                            {
                                /* buttons */
                                copyright ?
                            <div className="ion-padding">
                                <IonButton className="main-but ion-margin-top ion-margin-bottom" color="primary" expand="block" onClick={reportToAdmin}>
                                    { GetStr(LANGUAGE.TXT_REPORT_COPYRIGHT) }
                                </IonButton>
                                <IonButton className="main-but ion-margin-top ion-margin-bottom" color="secondary" expand="block" onClick={()=>setCopyright(false)}>
                                    { GetStr(LANGUAGE.TXT_REPORT_ADMIN) }
                                </IonButton>
                            </div>
                                :
                            <div className="ion-padding">
                                <IonButton className="main-but ion-margin-top ion-margin-bottom" color="primary" expand="block" onClick={reportToAdmin}>
                                    { GetStr(LANGUAGE.TXT_REPORT_ADMIN) }
                                </IonButton>
                                <IonButton className="main-but ion-margin-top ion-margin-bottom" color="secondary" expand="block" onClick={()=>setCopyright(true)}>
                                    { GetStr(LANGUAGE.TXT_REPORT_COPYRIGHT) }
                                </IonButton>
                            </div>
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Report;